import React, { useEffect, useState } from "react";
import { Quote, Star, ChevronLeft, ChevronRight } from "lucide-react";
import api from "../lib/api";

export default function TestimonialsSection() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get("/testimonials", { params: { active_only: true } }).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 6000);
    return () => clearInterval(t);
  }, [items.length]);

  if (items.length === 0) return null;
  const current = items[idx];

  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="absolute top-10 left-10 w-80 h-80 bg-yellow-50 rounded-full blur-3xl" />
      <div className="absolute bottom-10 right-10 w-80 h-80 bg-blue-50 rounded-full blur-3xl" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-12">
          <p className="kicker mb-3">Student Speak</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0B2A6B]">
            Voices of our <span className="text-yellow-500">success stories</span>
          </h2>
        </div>

        <div className="relative bg-white rounded-3xl shadow-xl border border-slate-100 p-10 md:p-14">
          <Quote className="absolute top-6 right-8 h-24 w-24 text-yellow-100" />
          <div className="relative">
            <div className="flex gap-1 mb-5">
              {Array.from({ length: current.rating }).map((_, i) => (
                <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <p className="text-xl md:text-2xl text-slate-700 leading-relaxed italic mb-8">
              “{current.quote}”
            </p>
            <div className="flex items-center gap-4">
              <img
                src={current.image_url}
                alt={current.name}
                className="h-14 w-14 rounded-full object-cover ring-4 ring-yellow-100"
              />
              <div>
                <div className="font-bold text-[#0B2A6B]">{current.name}</div>
                <div className="text-sm text-slate-500">{current.role}</div>
              </div>
            </div>
          </div>

          {/* Controls */}
          {items.length > 1 && (
            <div className="absolute bottom-6 right-6 flex items-center gap-2">
              <button
                onClick={() => setIdx((i) => (i - 1 + items.length) % items.length)}
                className="h-10 w-10 rounded-full bg-slate-100 hover:bg-yellow-400 hover:text-[#0B2A6B] text-slate-600 flex items-center justify-center transition"
              >
                <ChevronLeft className="h-5 w-5" />
              </button>
              <button
                onClick={() => setIdx((i) => (i + 1) % items.length)}
                className="h-10 w-10 rounded-full bg-yellow-400 hover:bg-[#0B2A6B] hover:text-white text-[#0B2A6B] flex items-center justify-center transition"
              >
                <ChevronRight className="h-5 w-5" />
              </button>
            </div>
          )}
        </div>

        <div className="mt-6 flex justify-center gap-2">
          {items.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              className={`h-2 rounded-full transition-all ${i === idx ? "w-8 bg-yellow-400" : "w-2 bg-slate-300"}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
